import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TokenType } from '../../types/Session.type'

interface UserState {
  user: TokenType | null
  _persist?: {
    version: number
    rehydrated: boolean
  }
}

const initialState: UserState = {
  user: null,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<TokenType>) {
      state.user = action.payload
    },
    clearUser(state) {
      state.user = null
    },
  },
})

export const { setUser, clearUser } = userSlice.actions
export default userSlice.reducer
